module.exports = __webpack_public_path__ + "static/media/Wave_Load.7ee6ed1e.svg";